class CodefyServicesAccordion extends HTMLElement {
  #controller = new AbortController();
  #observer = null;
  #openIndex = 0;
  #bars = [];
  #rows = [];

  connectedCallback() {
    const { signal } = this.#controller;
    this.#bars = Array.from(this.querySelectorAll('.cdfy-acc__bar'));
    this.#rows = Array.from(this.querySelectorAll('.cdfy-acc__row'));

    this.#bars.forEach((bar) => {
      bar.addEventListener('click', () => {
        const idx = parseInt(bar.getAttribute('data-idx'));
        this.#toggleIndex(idx);
      }, { signal });
    });

    const scrollOpenDesktop = this.getAttribute('data-scroll-open') === 'true';
    const scrollOpenMobile = this.getAttribute('data-scroll-open-mobile') === 'true';
    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const scrollOpenActive = isMobile ? scrollOpenMobile : scrollOpenDesktop;

    if (scrollOpenActive && !isReducedMotion) {
      this.#observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = parseInt(entry.target.getAttribute('data-idx'));
            this.#openIndexOnly(idx);
          }
        });
      }, {
        threshold: 0.85,
        rootMargin: '-20% 0px -20% 0px'
      });

      this.#bars.forEach((bar) => {
        this.#observer.observe(bar);
      });
    }

    this.#openIndexOnly(0);
  }

  disconnectedCallback() {
    this.#controller.abort();
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
  }

  #toggleIndex(index) {
    if (this.#openIndex === index) {
      this.#rows[index].classList.remove('open');
      this.#openIndex = -1;
    } else {
      this.#openIndexOnly(index);
    }
  }

  #openIndexOnly(index) {
    this.#rows.forEach((row, i) => {
      row.classList.toggle('open', i === index);
    });
    this.#openIndex = index;
  }
}

if (!customElements.get('codefy-services-accordion')) {
  customElements.define('codefy-services-accordion', CodefyServicesAccordion);
}
